/**
 * Rank badge mapping for UI.
 * Suggested location: src/assets/ranks (copy the svg files there)
 */
export type RankName = "Rookie" | "Bronze" | "Silber" | "Gold" | "Diamond" | "Elite";

export const RANK_BADGES: Record<RankName, {
  label: string;
  icon: string;           // relative importable path (bundler)
  tone: "neutral" | "bronze" | "silver" | "gold" | "diamond" | "elite";
  primary: string;        // hex
  secondary: string;      // hex
}> = {
  Rookie:  { label: "Rookie",  icon: "/assets/ranks/rookie.svg",  tone: "neutral", primary: "#6B7280", secondary: "#3B82F6" },
  Bronze:  { label: "Bronze",  icon: "/assets/ranks/bronze.svg",  tone: "bronze",  primary: "#B45309", secondary: "#CD7F32" },
  Silber:  { label: "Silber",  icon: "/assets/ranks/silber.svg",  tone: "silver",  primary: "#6B7280", secondary: "#C0C0C0" },
  Gold:    { label: "Gold",    icon: "/assets/ranks/gold.svg",    tone: "gold",    primary: "#B45309", secondary: "#FFD700" },
  Diamond: { label: "Diamond", icon: "/assets/ranks/diamond.svg", tone: "diamond", primary: "#1D4ED8", secondary: "#38BDF8" },
  Elite:   { label: "Elite",   icon: "/assets/ranks/elite.svg",   tone: "elite",   primary: "#6D28D9", secondary: "#F59E0B" },
};

// Helper: get badge by rank name safely
export function getRankBadge(rankName: string) {
  return (RANK_BADGES as any)[rankName] ?? RANK_BADGES.Rookie;
}
